import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { Radio } from '../../ui-kit/Radio/Radio.js';
export const VED_TYPES = [
    'currencyControl',
    'documentOperations',
    'conversionTransactions',
    'otherIssues',
];
export const VedField = JSX(({ field }) => {
    const { value, onChange } = field('vedTypes');
    useEffect(() => {
        if (value !== 'currencyControl') {
            field?.('inn')?.onChange?.('');
            field?.('region')?.onChange?.('');
        }
    }, [value]);
    return (_jsxs("div", { className: "py-m gap-m grid @xl:flex @xl:items-center", children: [_jsx(Radio, { name: "vedTypes", text: "\u0412\u0430\u043B\u044E\u0442\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C", value: "currencyControl", checked: value === 'currencyControl', onChange: onChange }), _jsx(Radio, { name: "vedTypes", text: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0440\u043D\u044B\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438", value: "documentOperations", checked: value === 'documentOperations', onChange: onChange }), _jsx(Radio, { name: "vedTypes", text: "\u041A\u043E\u043D\u0432\u0435\u0440\u0441\u0438\u043E\u043D\u043D\u044B\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438", value: "conversionTransactions", checked: value === 'conversionTransactions', onChange: onChange }), _jsx(Radio, { name: "vedTypes", text: "\u0418\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u0412\u042D\u0414", value: "otherIssues", checked: value === 'otherIssues', onChange: onChange })] }));
});
//# sourceMappingURL=VedField.js.map